import React from 'react';
import { motion } from "framer-motion";
import styled from 'styled-components';

const Switcher = ({toggle, toggleLight, status, toggleDark, themeToggleStatus}) => {
    return (
        <Container>
            <Social onClick={() => window.open("/austinemmanuelkim_resume_2026.pdf")} target="_blank">RESUME</Social>
            <Social href="mailto:austinkim.work@gmail.com" target="_blank">EMAIL</Social>
            <Label onClick={toggle}>{status ? "DARK ✦ MODE" : "LIGHT ✧ MODE"}</Label>
        </Container>
    );
};

export default Switcher;

// STYLES ------------------------

const Container = styled.div`
    z-index: 999;
    position: fixed;
    display: flex;
    // grid-template-columns: 1fr 1fr 1fr;

    width: fit-content;
    bottom: 25px;
    top: 12px;
    height: fit-content;
    left: 16px;
    // padding: 4px 4px 3px 4px;
    color: ${props => props.theme.primary};
    // background: green;

    @media screen and (max-width: 767px) {
        z-index: 1000;
        top: unset;
        right: unset;
        left: 8px;
        bottom: 2px;
        padding: 5px 8px 4px 8px;
        border: 1px solid ${props => props.theme.primary};
        background: ${props => props.theme.bg};
        opacity: 1;
        width: calc(100vw - 16px);

        &:hover {
            background: ${props => props.theme.bg};
            color: ${props => props.theme.primary};
        }
    }
`

const Label = styled.div`
    text-align: right;
    font-size: 11.5px;
    font-family: 'Verdana';

    // padding: 3px 0 1px 6px;
    margin-left: 30px;
    padding-top: 1px;
    opacity: .6;
    // border: 1px solid ${props => props.theme.bg};
    user-select: none;

    &:hover {
        cursor: pointer;
        // border: 1px solid ${props => props.theme.primary};
        opacity: .6;
    }

    @media screen and (max-width: 767px) {
        /* display: none; */
        display: grid;
        text-align: right;
        font-size: 13px;
        color: ${props => props.theme.primary};
        // background: green;
        width: 100%;
    }
`

const Social = styled.a`
    // display: list-item;
    font-family: 'Verdana';
    font-size: 11.5px;
    text-decoration: none;
    // text-align: center;
    width: fit-content;

    // padding: 3px 4px 3px 4px;
    padding-right: 18px;
    // margin-bottom: 8px;
    color: ${props => props.theme.primary};;
    border: 1px solid ${props => props.theme.bg};

    &:hover {
        // opacity: 0.6;
        cursor: pointer;
        border: 1px solid ${props => props.theme.primary};
        // color: ${props => props.theme.bg};
        // background: ${props => props.theme.primary};
    }

    @media screen and (max-width: 767px) {
        /* display: none; */
        display: grid;
        text-align: left;
        font-size: 13px;
        width: 50%;
        color: ${props => props.theme.primary};
    }

`
